var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn delete-btn",attrs:{"disabled":_vm.disabled,"title":"delete"}},[_c('img',{attrs:{"src":require("@/assets/icons/ui/trash-outline-red.svg"),"alt":"delete"}})])}
var staticRenderFns = []

export { render, staticRenderFns }